import { useQuery } from "@tanstack/react-query";
import { useCurrentCompanyId } from "hooks/auth";
import { StaleTime } from "newui/store/tanstack-base";
import { getSupplierPerformanceDetail } from "../api/supplier-performance-api";
import { SUPPLIER_PERFORMANCE_QUERY_KEYS } from "../constants/query-keys";
import type { SupplierPerformanceDetail } from "../types/supplier-performance.types";

export const useSupplierDetail = (supplierId: number | null) => {
	const companyId = useCurrentCompanyId();

	return useQuery<SupplierPerformanceDetail>({
		queryKey: SUPPLIER_PERFORMANCE_QUERY_KEYS.supplierDetail(
			companyId ?? 0,
			supplierId ?? 0
		),
		queryFn: () =>
			getSupplierPerformanceDetail(companyId!, supplierId!),
		enabled: companyId !== null && supplierId !== null,
		staleTime: StaleTime.Short,
	});
};
